import request from "../utils/request";

export function GET_Smtp(token) {
  return request.get("/Setting/Smtp", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function PUT_Smtp(token, payload) {
  return request.put("/Setting/Smtp", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function POST_SmtpTest(token, payload) {
  return request.post("/Setting/Smtp/Test", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function GET_NotificationPref(token) {
  return request.get("/Setting/Notification", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function PUT_NotificationPref(token, payload) {
  return request.put("/Setting/Notification", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}
